/*       */

/**
 * Simple Redux Middleware to prevent old actions to override the latest action for @@affectli LOAD actions
 * 
 * Only processes actions that start with '@@affectli' and include 'LOAD' and ensures only
 * the latest action of each type updates the store.
 */

const latestTimestamps = new Map();

const latestActionMiddleware = () => (next) => (action) => {
    if (!action || !action.type || !action.type.startsWith('@@affectli') || !action.type.includes('LOAD') || Object.isFrozen(action.meta)) {
        return next(action);
    }

    const timestamp = action.meta?.timestamp || Date.now();
    
    if (!action.meta) {
        action.meta = {};
    }

    try {
        if (!action.meta.timestamp) {
            action.meta.timestamp = timestamp;
        }
    } catch (error) {}
   
    
    const latestTimestamp = latestTimestamps.get(action.type);
    
    if (latestTimestamp === undefined) {
        latestTimestamps.set(action.type, timestamp);
        return next(action);
    }
    
    if (timestamp >= latestTimestamp) {
        latestTimestamps.set(action.type, timestamp);
        return next(action);
    }
    
    return { type: '@@OLD_ACTION_IGNORED', meta: { originalAction: action } };
};

export default latestActionMiddleware;
